var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebCheckerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 100 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.716,97.658h11.804c1.854,0,3.356-1.502,3.356-3.356s-1.502-3.356-3.356-3.356H17.716c-4.965,0-9.004-4.173-9.004-9.302 V33.89h81.22v12.082c0,1.854,1.503,3.356,3.356,3.356s3.356-1.502,3.356-3.356V18.523c0-8.771-7.31-16.181-15.963-16.181H17.716 C9.05,2.342,2,9.601,2,18.523v63.12C2,90.473,9.05,97.658,17.716,97.658z M8.712,18.523c0-5.133,4.123-9.469,9.004-9.469h62.965 c4.928,0,9.251,4.425,9.251,9.469v8.655H8.712V18.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.521,15.767h-1.342c-1.853,0-3.356,1.502-3.356,3.356s1.503,3.356,3.356,3.356h1.342c1.853,0,3.356-1.502,3.356-3.356 S80.374,15.767,78.521,15.767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.11,15.767h-1.342c-1.853,0-3.356,1.502-3.356,3.356s1.503,3.356,3.356,3.356h1.342c1.853,0,3.356-1.502,3.356-3.356 S68.963,15.767,67.11,15.767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.028,15.767h-1.342c-1.853,0-3.356,1.502-3.356,3.356s1.503,3.356,3.356,3.356h1.342c1.853,0,3.356-1.502,3.356-3.356 S56.881,15.767,55.028,15.767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.209,49.112c-14.718,0-28.114,9.243-33.334,22.999l-0.452,1.191l0.452,1.191c5.22,13.756,18.616,22.999,33.334,22.999 c14.722,0,28.12-9.243,33.34-23L98,73.302l-0.452-1.19C92.329,58.354,78.93,49.112,64.209,49.112z M64.209,90.78 c-11.518,0-22.038-6.972-26.576-17.478c4.538-10.506,15.058-17.478,26.576-17.478c11.521,0,22.043,6.972,26.581,17.478 C86.252,83.808,75.73,90.78,64.209,90.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.212,60.279c-7.181,0-13.023,5.842-13.023,13.023s5.842,13.023,13.023,13.023c7.181,0,13.023-5.842,13.023-13.023 S71.392,60.279,64.212,60.279z M64.212,79.612c-3.48,0-6.311-2.831-6.311-6.311c0-3.479,2.831-6.311,6.311-6.311 c3.48,0,6.311,2.831,6.311,6.311C70.522,76.781,67.691,79.612,64.212,79.612z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCheckerWhite);
export default __webpack_public_path__ + "static/media/webCheckerWhite.b08c4ea18d8879b3c2b7a2a3666ca3be.svg";
export { ForwardRef as ReactComponent };